module.exports = __webpack_public_path__ + "static/media/kp.7b223731.svg";